import { isEmpty } from 'lodash';
import React, { useCallback, useContext, useState } from 'react';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBBottomSheet } from '@shared/components/bottomSheet';
import { MBButton } from '@shared/components/button';
import { MBAutosizeTextInput } from '@shared/components/textInput';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext, grid } from '@shared/styles';
import { Trigger, useBoolean, useExecuteOnTrigger } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { WorkflowComponentStyles } from './WorkflowComponentStyles';

interface Props {
  answerTrigger: Trigger;
  label: string;
  value: string;
  anchorName: string;
  onChange(newValue: string): void;
  isReadOnly?: boolean;
}

export function WorkflowAuditTextarea({
  answerTrigger,
  label,
  value,
  anchorName,
  onChange,
  isReadOnly,
}: Props) {
  const colors = useContext(ColorThemeContext);
  const [sheetVisible, showSheet, hideSheet] = useBoolean(false);
  const [localValue, setLocalValue] = useState(value);
  const onOk = useCallback(() => {
    onChange(localValue);
    hideSheet();
  }, [localValue, onChange, hideSheet]);
  useExecuteOnTrigger(answerTrigger, showSheet);

  return (
    <>
      <View paddingBottom={2}>
        <MBTextBody1 flex>{label}</MBTextBody1>
      </View>
      {!isEmpty(value) && (
        <MBTouchableOpacity disabled={isReadOnly} onPress={showSheet}>
          <MBView
            style={WorkflowComponentStyles.textarea}
            paddingVertical={2}
            paddingHorizontal={1}
          >
            <MBTextBody1>{value}</MBTextBody1>
          </MBView>
        </MBTouchableOpacity>
      )}
      {sheetVisible && (
        <MBBottomSheet
          initialSize="half"
          onClose={hideSheet}
          title={i18n('card.blocks.question.answerButtonLabel')}
          anchorName={anchorName}
          style={{ minWidth: grid(40) }}
        >
          <View fill padding={2}>
            <MBAutosizeTextInput
              style={{ backgroundColor: colors.backgroundInactive, borderRadius: grid(1) }}
              onChangeText={setLocalValue}
              initialValue={value}
              placeholder={i18n('card.blocks.question.answerPlaceholder')}
              autoFocus
              padding="normal"
            />
            <View paddingBottom={2} />
            <MBButton title={i18n('common.ok')} onPress={onOk} />
          </View>
        </MBBottomSheet>
      )}
    </>
  );
}
